import { render, staticRenderFns } from "./ManageNotification.vue?vue&type=template&id=13762faa&scoped=true"
import script from "./ManageNotification.vue?vue&type=script&lang=js"
export * from "./ManageNotification.vue?vue&type=script&lang=js"
import style0 from "./ManageNotification.vue?vue&type=style&index=0&id=13762faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13762faa",
  null
  
)

export default component.exports